import classNames from 'classnames';
import type { BulletPattern, BulletVariant } from 'components/BulletIndicator';
import BulletIndicator from 'components/BulletIndicator';
import React from 'react';
import styles from './index.module.scss';

export interface Props {
  label: string;
  /** Primary value */
  value?: React.ReactNode;
  /** Align all values horizontally (`children` bypasses this)  */
  alignValues?: boolean;
  /** Secondary, muted value? */
  secondaryValue?: React.ReactNode;
  size?: 'xsmall' | 'small' | 'medium' | 'large';
  /** Append after values (unstyled) */
  children?: React.ReactNode;
  className?: string;
  /** Show a bullet prepending this value? Also see bulletVariant */
  bullet?: boolean;
  bulletVariant?: BulletVariant;
  bulletPattern?: BulletPattern;
}

export const LabelValue = (props: Props) => {
  const { alignValues = true } = props;
  const containerClass = classNames(
    styles.container,
    styles[`size-${props.size || 'medium'}`],
    props.className
  );

  return (
    <div className={containerClass}>
      <div className={styles.label}>{props.label}</div>
      <div className={classNames(styles.value, { [styles.alignValues]: alignValues })}>
        {!!props.bullet && (
          <BulletIndicator
            variant={props.bulletVariant}
            pattern={props.bulletPattern}
            size={props.size || 'medium'}
          />
        )}
        <div>{props.value}</div>
        {!!props.secondaryValue && (
          <div className={styles.secondaryValue}>{props.secondaryValue}</div>
        )}
      </div>
      {props.children}
    </div>
  );
};

LabelValue.defaultProps = {};

export default LabelValue;
